import { render } from "./template.vue?vue&type=template&id=42d770ac&scoped=true&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=42d770ac&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d770ac"]])

export default __exports__